abstract class ErrorBase implements IError {
    static errorId = 0;

    type: ErrorTypeEnum;
    id: number;
    datetime: string;
    context: string;
    url: string;
    parameters: string;
    stackTrace: string;
    errorMessage: string;
    userMessage: string;
    exception: any;

    constructor(data: IError) {
        ErrorBase.errorId++;

        this.id = ErrorBase.errorId;
        this.datetime = DevExpress.localization.formatDate(new Date(), irSettings.shortDateTimeFormat);

        this.context = data.context ?? "";
        this.url = data.url ?? "";
        this.parameters = data.parameters ?? "";
        this.stackTrace = data.stackTrace ?? "";
        this.errorMessage = data.errorMessage ?? "";
        this.userMessage = data.userMessage ?? "";
        this.exception = data.exception;
    }

    abstract toString(): string;
}